import clsx from 'clsx';

interface StatCardProps {
  icon?: React.ForwardRefExoticComponent<React.SVGProps<SVGSVGElement>>;
  label: string;
  value: string | number;
  trend?: { direction: 'up' | 'down' | 'flat'; label: string };
  className?: string;
}

export default function StatCard({ icon: Icon, label, value, trend, className }: StatCardProps) {
  return (
    <div className={clsx('bg-white rounded-lg border border-gray-100 shadow-sm p-5', className)}>
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-ocean-50">
            <Icon className="h-5 w-5 text-ocean-600" />
          </div>
        )}
        <div className="min-w-0">
          <p className="text-sm text-gray-500 truncate">{label}</p>
          <p className="text-2xl font-semibold text-navy-900 tabular-nums">{value}</p>
        </div>
      </div>
      {trend && (
        <p
          className={clsx(
            'mt-2 text-xs font-medium',
            trend.direction === 'up' && 'text-green-600',
            trend.direction === 'down' && 'text-red-600',
            trend.direction === 'flat' && 'text-gray-500',
          )}
        >
          {trend.direction === 'up' && '\u2191 '}
          {trend.direction === 'down' && '\u2193 '}
          {trend.label}
        </p>
      )}
    </div>
  );
}
